import React from 'react';

import '../../styles/content-grid.scss';

import { formatNumber } from '@Saral-Influencer-Marketing/saral-utils/dist/functions/formulas/number';

import CustomTooltip from '../../../../common-components/CustomTooltip/CustomTooltip';
import ImpressionsIcon from '../../../../Icons/icons/ImpressionsIcon';
import BookmarkIcon from '../../../../Icons/icons/PlayerIcon/BookmarkIcon';
import CommentIcon from '../../../../Icons/icons/PlayerIcon/CommentIcon';
import HeartLikeIcon from '../../../../Icons/icons/PlayerIcon/HeartLikeIcon';
import ShareIcon from '../../../../Icons/icons/PlayerIcon/ShareIcon';
import { useCampaignDetail } from '../CampaignDetails/CampaignDetailProvider';

const CardStats = ({ likes, comments, saves, shares, views, type, post }) => {
  const { setLabelModalOpen } = useCampaignDetail();

  const renderStatItem = (count, IconComponent, tooltip, props) => {
    return count !== null && count !== undefined && count >= 0 ? (
      <CustomTooltip title={tooltip} placement="top">
        <div className="card-stat-item">
          <IconComponent {...props} className="card-stat-icon" />
          <div>{formatNumber({ num: count, isInt: true, isTruncated: true })}</div>
        </div>
      </CustomTooltip>
    ) : null;
  };

  return (
    <div className="card-stats-container">
      {renderStatItem(likes, HeartLikeIcon, 'Likes')}
      {renderStatItem(comments, CommentIcon, 'Comments')}
      {['reel', 'ttVideo'].includes(type) &&
        renderStatItem(views, ImpressionsIcon, 'Views', {
          color: '#fff',
        })}
      {renderStatItem(shares, ShareIcon, 'Shares')}
      <div className="card-stat-item-add-label">
        <CustomTooltip title="Add Label" placement="top">
          <div
            className="card-stat-item"
            onClick={() => {
              setLabelModalOpen({ post: post, openModal: 'addLabel' });
            }}>
            <BookmarkIcon />
            <span>Label</span>
          </div>
        </CustomTooltip>
      </div>
    </div>
  );
};

export default CardStats;
